import { useCopyToClipboard } from '@gogame/hooks-ts';
import { useScreenMessage } from '@gogame/screens';

export const useCopyCampaignHybridLink = (process) => {
  const { showErrorMessage, showSuccessMessage } = useScreenMessage();
  const copyToClipboard = useCopyToClipboard();
  return ({ hybridLink }) => {
    return process(copyToClipboard(hybridLink))
      .then(() => {
        showSuccessMessage(
          `Campaign hybrid link «${hybridLink}» copied to clipboard`
        );
      })
      .catch((e) => {
        showErrorMessage(e.message);
        return Promise.reject(e);
      });
  };
};
